import React from 'react';
import {Button, Col, Form, Input, Modal, Row} from 'antd';
import Colors from "../../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";

interface IngredientModalProps {
    element: object;
    visible: boolean;
    onClose: () => void;
}

const PlantillaModal: React.FC<IngredientModalProps> = ({element, visible, onClose}) => {
    const [form] = Form.useForm();

    const handleSubmit = () => {
        form.submit();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <Modal
            title="Editar Contacte"
            open={visible}
            onCancel={handleCancel}
            footer={[
                <>
                    <Button title={"Acceptar"} style={{backgroundColor: Colors.colors.color6}}
                            onClick={handleSubmit}><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </>
            ]}
            width={800}
        >
            <Form form={form} initialValues={element}>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item label="ID" name="id">
                            <Input disabled/>
                        </Form.Item>
                        <Form.Item label="Nom" name="nom">
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Cognoms" name="cognoms" required>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Telefon" name="telefon" required>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Telefon 2" name="telefon2">
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Telefon 3" name="telefon3">
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Email" name="email" required>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="Parentesc" name="parentesc" required>
                            <Input/>
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Direccio" name="direccio">
                            <Input/>
                        </Form.Item>
                        <Form.Item label="DNI" name="dni" required>
                            <Input/>
                        </Form.Item>
                        <Form.Item label="IBAN" name="IBAN">
                            <Input/>
                        </Form.Item>
                        <Form.Item label="IBAN Entitat" name="IBANentitat">
                            <Input/>
                        </Form.Item>
                        <Form.Item label="IBAN Oficina" name="IBANoficina">
                            <Input/>
                        </Form.Item>
                        <Form.Item label="IBAN DC" name="IBANdc">
                            <Input/>
                        </Form.Item>
                        <Form.Item label="IBAN Num" name="IBANnum">
                            <Input/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

        </Modal>
    );
};

export default PlantillaModal;
